<div *ngIf="canLoad">
  <h5>{{ tableLabel }}</h5>
  <app-datatable
    [dataSourceUrl]="dtDataSourceUrl"
    [settings]="dtSettings"
    [events]="dtEvents"
    (onInit)="onDtInit($event)"
    (onAction)="onAction($event)"
  >
    <th class="column-hide" data-data="id">Azonosító</th>
    <th data-data="order">Sorrend</th>
    <th data-data="name">Vizsgatárgy neve</th>
    <th data-data="description">Vizsgatárgy leírása</th>
    <th data-data="grossTimeLimitMinutes">Bruttó időkeret (perc)</th>
    <th class="datetime" data-data="startDateAtUtc">Kezdés időpont</th>
    <th data-data="timeLimitMultiplier">SNI időkeret szorzó</th>
    <th class="column-actions">Műveletek</th>
  </app-datatable>
</div>
